import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

import Layout from "./components/Layout";
import AuthCallback from "./auth/AuthCallback";
import ProtectedRoute from "./auth/ProtectedRoute";

const Home = lazy(() => import("./pages/Home"));
const Services = lazy(() => import("./pages/Services"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Legal = lazy(() => import("./pages/Legal"));
const Login = lazy(() => import("./pages/Login"));
const ClientSpace = lazy(() => import("./pages/ClientSpace"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DemoVitrineLayout = lazy(() => import("./pages/demo-vitrine/DemoVitrineLayout"));
const DemoVitrineHome = lazy(() => import("./pages/demo-vitrine/DemoVitrineHome"));
const DemoVitrineMenu = lazy(() => import("./pages/demo-vitrine/DemoVitrineMenu"));
const DemoVitrineContact = lazy(() => import("./pages/demo-vitrine/DemoVitrineContact"));

function PageLoader() {
  return (
    <div className="min-h-screen bg-void flex items-center justify-center">
      <Loader2 size={20} className="animate-spin text-acid" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/fr/exemples/vitrine" element={<DemoVitrineLayout />}>
          <Route index element={<DemoVitrineHome />} />
          <Route path="menu" element={<DemoVitrineMenu />} />
          <Route path="contact" element={<DemoVitrineContact />} />
        </Route>
        <Route path="/en/examples/showcase" element={<DemoVitrineLayout />}>
          <Route index element={<DemoVitrineHome />} />
          <Route path="menu" element={<DemoVitrineMenu />} />
          <Route path="contact" element={<DemoVitrineContact />} />
        </Route>

        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/fr/home" element={<Navigate to="/" replace />} />
          <Route path="/fr" element={<Navigate to="/" replace />} />

          <Route path="/fr/services" element={<Services />} />
          <Route path="/fr/portfolio" element={<Portfolio />} />
          <Route path="/fr/realisations" element={<Navigate to="/fr/portfolio" replace />} />
          <Route path="/fr/a-propos" element={<About />} />
          <Route path="/fr/contact" element={<Contact />} />
          <Route path="/fr/mentions-legales" element={<Legal />} />
          <Route path="/fr/connexion" element={<Login />} />
          <Route
            path="/fr/espace-client"
            element={
              <ProtectedRoute>
                <ClientSpace />
              </ProtectedRoute>
            }
          />
          <Route path="/fr/admin" element={<Admin />} />

          <Route path="/en/home" element={<Home />} />
          <Route path="/en" element={<Navigate to="/en/home" replace />} />
          <Route path="/en/services" element={<Services />} />
          <Route path="/en/portfolio" element={<Portfolio />} />
          <Route path="/en/projects" element={<Navigate to="/en/portfolio" replace />} />
          <Route path="/en/about" element={<About />} />
          <Route path="/en/contact" element={<Contact />} />
          <Route path="/en/legal-notice" element={<Legal />} />
          <Route path="/en/login" element={<Login />} />
          <Route
            path="/en/client-area"
            element={
              <ProtectedRoute>
                <ClientSpace />
              </ProtectedRoute>
            }
          />
          <Route path="/en/admin" element={<Admin />} />

          <Route path="/exemples/vitrine" element={<Navigate to="/fr/exemples/vitrine" replace />} />
          <Route path="/a-propos" element={<Navigate to="/fr/a-propos" replace />} />
          <Route path="/contact" element={<Navigate to="/fr/contact" replace />} />
          <Route path="/services" element={<Navigate to="/fr/services" replace />} />
          <Route path="/mentions-legales" element={<Navigate to="/fr/mentions-legales" replace />} />
          <Route path="/espace-client" element={<Navigate to="/fr/espace-client" replace />} />
          <Route path="/connexion" element={<Navigate to="/fr/connexion" replace />} />
          <Route path="/admin" element={<Navigate to="/fr/admin" replace />} />

          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </Suspense>
  );
}
